import { render, staticRenderFns } from "./RequestTemplate.vue?vue&type=template&id=8eb20f98&scoped=true"
import script from "./RequestTemplate.vue?vue&type=script&lang=js"
export * from "./RequestTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb20f98",
  null
  
)

export default component.exports